/**

 @Projekt:
 @Autor:    LEMONIT
 @Zakodował: MK
 @Data:      08/2018
 -------------------
 SKRYPTY.JS
 -------------------

 **/

window.mobileAndTabletcheck = function () {
    var check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

window.get_browser = function () {
    var ua = navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {name: 'IE', version: (tem[1] || '')};
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/)
        if (tem != null) {
            return {name: 'Opera', version: tem[1]};
        }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }
    return {
        name: M[0],
        version: M[1]
    };
}

var LEMON = {
    buttonscroll: function () {
        $('#go_to_next_section').click(function (event) {
            event.preventDefault();
            var $anchor = $(this).closest('section').nextAll('section').first().offset();
            if ($(window).width() < 991) {
                $('html, body').animate({scrollTop: $anchor.top - 66}, 1000);
            } else {
                $('html, body').animate({scrollTop: $anchor.top - 100}, 1000);
            }
            return false;
        });

        $('.footer-button').click(function (event) {
            event.preventDefault();
            $('html, body').animate({scrollTop: 0}, 1000);
            return false;
        });

        function toggleFixedButton() {
            if ($(window).width() > 767) {
                if ($(document).scrollTop() > 100) {
                    $('.footer-button.fixed').addClass('show');
                    $('.footer-button.fixed').removeClass('hidden');
                } else {
                    $('.footer-button.fixed').addClass('hidden');
                    $('.footer-button.fixed').removeClass('show');
                }
            } else {
                $('.footer-button.fixed').addClass('hidden');
                $('.footer-button.fixed').removeClass('show');
            }

        }

        toggleFixedButton();

        $(document).scroll(function () {
            toggleFixedButton();
        });
    },
    carouselOffers: function () {
        $('.subpage-carousel').owlCarousel({
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 3000,
            dots: false,
            items: 3,
            loop: true,
            nav: true,
            navContainer: '.subpage-carousel-controls',
            navText: ['<i class="icon-strzalka_lewo"></i>', '<i class="icon-strzalka_prawo"></i>'],
            smartSpeed: 500,
            responsive: {
                0: {
                    items: 1
                },
                481: {
                    items: 3
                },
                992: {
                    items: 5
                }
            }
        });
    },
    cartFunctions: function (ajaxInitButton) {
        ajaxInitButton = ajaxInitButton || true;
        $('[data-toggle="tooltip"]').tooltip();

        $('.add-to-cart').on('touchend', function (event) {
            event.preventDefault();
            $(this).click();
        });

        $('.add-to-cart').unbind().click(function (event) {
            event.preventDefault();
            window.video_id = $(this).attr('data-id');
            window.video_res = $(this).attr('data-res');
            window.directory = $(this).attr('data-hash');
            window.clicked_button = $(this).parent();
            addToCart();
        });

        $('#modal-chooseresolution').on('click', '.choose-resolution', function (event) {
            $('#modal-chooseresolution').modal('hide');
            event.preventDefault();
            window.video_id = $(this).attr('data-id');
            window.video_res = $(this).attr('data-res');
            window.directory = $(this).attr('data-hash');
            addToCart();
        });

        $('.choose-resolution').click(function (event) {
            $('#modal-chooseresolution').modal('hide');
            event.preventDefault();
            window.video_id = $(this).attr('data-id');
            window.video_res = $(this).attr('data-res');
            window.directory = $(this).attr('data-hash');
            addToCart();
        });

        $('.select-folder').change(function () {
            var $checkedOption = $(this).find('option:checked'),
                $video_id = $checkedOption.attr('data-video-id'),
                $directory_hash = $checkedOption.attr('data-hash');

            isProductInCart($video_id, $directory_hash, true);
        });

        initProductButtons(ajaxInitButton);

        function initProductButtons($do_ajax) {
            if ($('.resolutions:not(.hidden)').length) {
                var $checkedOption = $('.select-folder').find('option:checked'),
                    $video_id = $checkedOption.attr('data-video-id'),
                    $directory_hash = $checkedOption.attr('data-hash');

                $('.resolutions:not(.hidden) tr td:last-child').each(function () {
                    $(this).html('<a href="#" class="add-to-cart add-with-resolution default-button default-button-fullwidth noidscroll" data-id="' + $(this).closest("table").attr("data-id") + '" data-res="' + $(this).closest("tr").attr("data-res") + '" data-hash="' + $directory_hash + '">\
						<i class="icon-koszyk_2"></i>\
							' + $(".js-text-language").attr("data-dodajdokoszyka") + '\
					</a>');
                });

                $('.resolutions tr td:last-child .add-to-cart').click(function (event) {
                    event.preventDefault();
                    window.video_id = $(this).attr('data-id');
                    window.video_res = $(this).attr('data-res');
                    window.directory = $(this).attr('data-hash');
                    if (!$(this).closest('.resolutions').hasClass('resolutions-stock')) {
                        window.clicked_button = $(this).parent();
                    }
                    addToCart();
                });

                isProductInCart($video_id, $directory_hash, $do_ajax);
            } else {
                refreshCart();
            }
        }

        function isProductInCart($video_id, $directory_hash, $do_ajax) {
            $language = window.location.href.split('//')[1].split('/')[1].replace('#', ''),
                $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/GetBasketInfo';

            if ($do_ajax == true) {
                $.ajax({
                    url: $url,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (ret) {
                        if (Object.keys(ret).length) {
                            initProductButtons(false);
                            var $is_video = false;
                            for (var $i = 0 in ret.products) {
                                if (ret.products[$i].id == $video_id && ret.products[$i].directory == $directory_hash) {
                                    $('.resolutions:not(.hidden) tr[data-res="' + ret.products[$i].res + '"] td:last-child').empty();
                                    if ($('.resolutions:not(.hidden)').hasClass('resolutions-stock')) {
                                        $('.resolutions:not(.hidden) tr[data-res="' + ret.products[$i].res + '"] td:last-child').append('\
											<div class="resolutions-info">\
												 ' + $(".js-text-language").attr("data-filmwkoszyku") + '\
											</div>');
                                        $is_video = true;
                                    } else {
                                        $('.resolutions:not(.hidden) tr[data-res="' + ret.products[$i].res + '"] td:last-child').append('\
											<div class="resolutions-info">\
												 ' + $(".js-text-language").attr("data-filmwkoszyku") + '\
											</div>\
											<a href="#" class="default-button default-button-fluidwidth noidscroll delete-video" data-id="' + $video_id + '" data-hash="' + $directory_hash + '">' + $(".js-text-language").attr("data-usunfilm") + '</a>');
                                        $is_video = true;
                                    }
                                }
                            }
                            if ($is_video) {
                                $('.resolutions:not(.hidden) a:not(.delete-video)').remove();
                            }
                            $('.delete-video').click(function (event) {
                                event.preventDefault();
                                deleteVideo($(this).attr('data-hash'), $(this).attr('data-id'));
                            });
                            $('.header-cart, .aside-cart').removeClass('hidden');
                            $('.header-cart-counter, .aside-cart-counter').text(ret.total_products_in_cart);
                        } else {
                            $('.header-cart, .aside-cart').addClass('hidden');
                        }
                    }
                });
            }
        }

        function addToCart() {
            var $language = window.location.href.split('//')[1].split('/')[1],
                $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/GetDirectory';

            $.ajax({
                url: $url,
                cache: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (ret) {
                    //czy są zdefiniowane foldery w koszyku
                    if (Object.keys(ret).length) {
                        //czy jest jeden folder w koszyku
                        if (Object.keys(ret).length == 1) {
                            window.more_directories = false;
                            window.amount_directories = Object.keys(ret).length;
                            //czy wybrano rozdzielczość do dodania w koszyku
                            if (window.video_res) {
                                saveToCart();
                            } else {
                                $('#modal-addtocart select.select-folder').empty();
                                $('.more-folders').addClass('hidden');
                                var $resolutions = window.clicked_button.siblings('.resolutions').clone();
                                $('#modal-chooseresolution .video-frame').html($resolutions);
                                $('#modal-chooseresolution .video-frame .resolutions').removeClass('hidden');
                                initProductButtons(false);
                                $('#modal-chooseresolution').modal({
                                    backdrop: 'static',
                                    keyboard: false,
                                    show: true
                                });
                            }
                            //czy jest więcej folderów w koszyku
                        } else {
                            //czy wybrano rozdzielczość do dodania w koszyku
                            if (window.video_res) {
                                window.more_directories = true;
                                window.amount_directories = Object.keys(ret).length;
                                saveToCart();
                            } else {
                                $('#modal-chooseresolution select.select-folder').empty();
                                for (var $i = 0; $i < Object.keys(ret).length; $i++) {
                                    $('#modal-chooseresolution select.select-folder').append('<option value="' + ret[Object.keys(ret)[$i]].name + '" data-video-id="' + window.video_id + '" data-hash="' + ret[Object.keys(ret)[$i]].hash + '">' + ret[Object.keys(ret)[$i]].name + '</option>');
                                }

                                $language = window.location.href.split('//')[1].split('/')[1].replace('#', ''),
                                    $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/GetBasketInfo';

                                $.ajax({
                                    url: $url,
                                    headers: {
                                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                    },
                                    success: function (ret) {
                                        if (Object.keys(ret).length) {
                                            var $count = 0;
                                            for (var $i = 0 in ret.products) {
                                                if (ret.products[$i].id == window.video_id) {
                                                    $('#modal-chooseresolution select.select-folder option[data-hash="' + ret.products[$i].directory + '"]').attr('disabled', 'disabled');
                                                }
                                            }
                                            $('#modal-chooseresolution select.select-folder option:not(:disabled)').first().attr('selected', 'selected');
                                            $('#modal-chooseresolution .select-folder').selectpicker('render');
                                            $('.more-folders').removeClass('hidden');
                                            var $resolutions = window.clicked_button.siblings('.resolutions').clone();
                                            $('#modal-chooseresolution .video-frame').html($resolutions);
                                            $('#modal-chooseresolution .video-frame .resolutions').removeClass('hidden');
                                            initProductButtons(true);
                                            $('#modal-chooseresolution').modal({
                                                backdrop: 'static',
                                                keyboard: false,
                                                show: true
                                            });
                                        }
                                    }
                                });
                            }
                        }
                    } else {
                        if (window.video_res) {
                            window.more_directories = false;
                            window.amount_directories = 0;
                            saveToCart();
                        } else {
                            $('#modal-addtocart select.select-folder').empty();
                            $('.more-folders').addClass('hidden');
                            var $resolutions = window.clicked_button.siblings('.resolutions').clone();
                            $('#modal-chooseresolution .video-frame').html($resolutions);
                            $('#modal-chooseresolution .video-frame .resolutions').removeClass('hidden');
                            initProductButtons(false);
                            $('#modal-chooseresolution').modal({
                                backdrop: 'static',
                                keyboard: false,
                                show: true
                            });
                        }
                    }
                }
            });
        }

        $('.save-to-cart').click(function (event) {
            saveToCart();
        });

        function saveToCart() {
            var $language = window.location.href.split('//')[1].split('/')[1],
                $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/AddProductToBasket?id=' + window.video_id + '&res=' + window.video_res,
                $dirHash = $('select.select-folder option:selected').attr('data-hash');

            if ($dirHash) {
                $url += '&dir=' + $dirHash;
            }

            $.ajax({
                url: $url,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (ret) {
                    if (ret.status == true) {
                        //$('#modal-addedtocart .info').text('Dodano video do koszyka.');
                        if (window.more_directories) {
                            if (window.clicked_button.find('a').hasClass('add-with-resolution')) {
                                window.clicked_button.html('\
									<div class="resolutions-info">\
										 ' + $(".js-text-language").attr("data-filmwkoszyku") + '\
									</div>\
									<a href="#" class="default-button default-button-fluidwidth noidscroll delete-video" data-id="' + window.video_id + '" data-hash="' + $dirHash + '">' + $(".js-text-language").attr("data-usunfilm") + '</a>');
                                $('.resolutions:not(.hidden) a:not(.delete-video)').remove();
                                $('.delete-video').click(function (event) {
                                    event.preventDefault();
                                    deleteVideo($(this).attr('data-hash'), $(this).attr('data-id'));
                                });
                                refreshCart();
                            } else {
                                $language = window.location.href.split('//')[1].split('/')[1].replace('#', ''),
                                    $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/GetBasketInfo';

                                $.ajax({
                                    url: $url,
                                    headers: {
                                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                    },
                                    success: function (ret) {
                                        if (Object.keys(ret).length) {
                                            var $count = 0;
                                            for (var $i = 0 in ret.products) {
                                                if (ret.products[$i].id == window.video_id) {
                                                    $count++;
                                                }
                                            }
                                            if (window.amount_directories == $count) {
                                                window.clicked_button.html('\
													<a href="#" class="default-button-nopointer noidscroll default-circlebutton pull-right" data-id="' + window.video_id + '" data-toggle="tooltip" data-placement="bottom" title="' + $(".js-text-language").attr("data-filmwewszystkichfolderach") + '">\
														<i class="icon-koszyk_2 color-orange"></i>\
													</a>');
                                                $('[data-toggle="tooltip"]').tooltip();
                                            } else {
                                                window.clicked_button.html('\
													<a href="#" class="add-to-cart noidscroll default-circlebutton pull-right" data-id="' + window.video_id + '" data-toggle="tooltip" data-placement="bottom" title="' + $(".js-text-language").attr("data-filmwkoszykudodajdoinnegofolderu") + '">\
														<i class="icon-koszyk_2 color-orange"></i>\
													</a>');
                                                window.clicked_button.find('a').click(function (event) {
                                                    event.preventDefault();
                                                    window.video_id = $(this).attr('data-id');
                                                    window.video_res = $(this).attr('data-res');
                                                    window.directory = $(this).attr('data-hash');
                                                    window.clicked_button = $(this).parent();
                                                    addToCart();
                                                });
                                                $('[data-toggle="tooltip"]').tooltip();
                                            }
                                        }
                                        refreshCart();
                                    }
                                });
                            }
                        } else {
                            if (window.clicked_button.find('a').hasClass('add-with-resolution')) {
                                window.clicked_button.html('\
									<div class="resolutions-info">\
										 ' + $(".js-text-language").attr("data-filmwkoszyku") + '\
									</div>\
									<a href="#" class="default-button default-button-fluidwidth noidscroll delete-video" data-id="' + window.video_id + '" data-hash="' + $dirHash + '">' + $(".js-text-language").attr("data-usunfilm") + '</a>');
                                $('.resolutions:not(.hidden) a:not(.delete-video)').remove();
                                $('.delete-video').click(function (event) {
                                    event.preventDefault();
                                    deleteVideo($(this).attr('data-hash'), $(this).attr('data-id'));
                                });
                            } else {
                                window.clicked_button.html('\
									<a href="#" class="default-button-nopointer default-circlebutton noidscroll pull-right" data-toggle="tooltip" data-placement="bottom" title="' + $(".js-text-language").attr("data-filmwkoszyku") + '">\
										<i class="icon-koszyk_2 color-orange"></i>\
									</a>');
                                $('[data-toggle="tooltip"]').tooltip();
                            }
                            refreshCart();
                        }
                    } else {
                        $('#modal-addedtocart .info').text(ret.info)
                    }
                    $('#modal-chooseresolution').modal('hide');
                    window.setTimeout(
                        function () {
                            $('#modal-addedtocart').modal('show');
                        }, 500);
                }
            });
        }

        $('.delete-video-from-cart').click(function (event) {
            event.preventDefault();
            $('#modal-deletevideofromcart .delete-video-link').attr('href', $(this).attr('href'));
            $('#modal-deletevideofromcart').modal('show');
        });


        $('.delete-video').click(function (event) {
            event.preventDefault();
            deleteVideo($(this).attr('data-hash'), $(this).attr('data-id'));
        });

        function deleteVideo($hash, $id) {
            var $language = window.location.href.split('//')[1].split('/')[1],
                $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/RemoveProductFromBasket?id=' + $hash + ':' + $id;

            $.ajax({
                url: $url,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (ret) {
                    if (ret.status == true) {
                        $('#modal-info .modal-title').text($(".js-text-language").attr("data-informacja"));
                        $('#modal-info .info').text(ret.info);
                    } else {
                        $('#modal-info .modal-title').text($(".js-text-language").attr("data-informacja"));
                        $('#modal-info .info').text(ret.info);
                    }
                    $('#modal-chooseresolution').modal('hide');
                    window.setTimeout(
                        function () {
                            $('#modal-info').modal('show');
                            initProductButtons(false);

                            refreshCart();
                        }, 500);
                }
            });
        }

        $('.new-folder').click(function (event) {
            $('#modal-newfolder').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        });

        $('.save-newfolder').click(function (event) {
            if ($('#newfolder-text').val() != '') {
                var $language = window.location.href.split('//')[1].split('/')[1],
                    $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/AddDirectory?name=' + $('#newfolder-text').val(),
                    $newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname

                $.ajax({
                    url: $url,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (ret) {
                        if (ret.status == true) {
                            $('#modal-info .modal-title').text($(".js-text-language").attr("data-informacja"));
                            $('#modal-info .info').text($(".js-text-language").attr("data-utworzonofolder") + ': ' + $('#newfolder-text').val());
                            $('.folders .dropdown-menu .divider').before('<li><a href="' + $newUrl + '?dir=' + ret.hash + '" class="noidscroll">' + $('#newfolder-text').val() + '</a></li>');
                            $('#newfolder-text').val('');
                        } else {
                            $('#modal-info .modal-title').text($(".js-text-language").attr("data-informacja"));
                            $('#modal-info .info').text(ret.info)
                        }
                        $('#modal-newfolder').modal('hide');
                        window.setTimeout(
                            function () {
                                $('#modal-info').modal('show');
                            }, 500);
                    }
                });
            } else {
                event.preventDefault();
                alert($(".js-text-language").attr("data-podajnazwefolderu"));
            }
        });

        $('#modal-newfolder').on('show.bs.modal', function (e) {
            $('#newfolder-text').val('');
        });

        $('.change-name').click(function (event) {
            window.folder_hash = $(this).attr('data-dir');
            window.old_folder_name = $(this).attr('data-name');
            $('#newname-text').val(window.old_folder_name);
            $('#modal-changename').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        });

        $('.save-newname').click(function (event) {
            if ($('#newname-text').val() != '') {
                var $language = window.location.href.split('//')[1].split('/')[1],
                    $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/RenameDirectory?name=' + $('#newname-text').val() + '&hash=' + window.folder_hash,
                    $newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname

                $.ajax({
                    url: $url,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (ret) {
                        if (ret.status == true) {
                            $('#modal-info .modal-title').text($(".js-text-language").attr("data-informacja"));
                            $('#modal-info .info').text('Zmieniono nazwę folderu "' + window.old_folder_name + '" na: ' + $('#newname-text').val());
                            $('.folders .dropdown-menu li.active a').text($('#newname-text').val());
                            $('.folders .title').text($('#newname-text').val());
                            $('.change-name').attr('data-name', $('#newname-text').val());
                            $('#newname-text').val('');
                            $('#modal-changename').modal('hide');
                        } else {
                            $('#modal-info .modal-title').text($(".js-text-language").attr("data-informacja"));
                            $('#modal-info .info').text(ret.info);
                            $('#modal-changename').modal('hide');
                            window.setTimeout(
                                function () {
                                    $('#modal-info').modal('show');
                                }, 500);
                        }
                    }
                });
            } else {
                event.preventDefault();
                alert($(".js-text-language").attr("data-podajnazwefolderu"));
            }
        });

        $('.add-folder-to-cart').click(function (event) {
            $('#modal-addfoldertocart').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        });

        $('.save-folder-to-cart').click(function (event) {
            if ($('#foldertocart-text').val() != '') {
                var $language = window.location.href.split('//')[1].split('/')[1],
                    $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/AddToBasketContentDirectoryByHash?hash=' + $('.add-folder-to-cart').attr('data-hash') + '&directory=' + $('#foldertocart-text').val();

                $.ajax({
                    url: $url,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (ret) {
                        if (ret.status == true) {
                            refreshCart();
                            $('#modal-addfoldertocart').modal('hide');
                            window.setTimeout(
                                function () {
                                    $('#modal-addedfoldertocart').modal('show');
                                }, 500);
                        } else {
                            $('#modal-addfoldertocart .info').text(ret.info)
                        }
                    }
                });
            } else {
                event.preventDefault();
                alert($(".js-text-language").attr("data-podajnazwefolderu"));
            }
        });

        $('.add-comment').click(function (event) {
            window.commentbox = $(this).closest('.categorycolumn').find('.video-comment');
            window.comment_video_id = $(this).attr('data-id');
            window.current_folder_hash = $(this).attr('data-hash');
            $('#message-text').val(window.commentbox.text());
            $('#modal-comment').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        });

        $('.save-comment').click(function (event) {
            var $language = window.location.href.split('//')[1].split('/')[1],
                $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/AddCommentToProd?id=' + window.current_folder_hash + ':' + window.comment_video_id + '&comment=' + $('#message-text').val();

            $.ajax({
                url: $url,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (ret) {
                    if (ret.status == true) {
                        $('#modal-info .modal-title').text($(".js-text-language").attr("data-informacja"));
                        $('#modal-info .info').text(ret.info);
                        window.commentbox.text($('#message-text').val());
                        $('#message-text').val('');
                        $('#modal-comment').modal('hide');
                    } else {
                        $('#modal-info .modal-title').text($(".js-text-language").attr("data-informacja"));
                        $('#modal-info .info').text(ret.info);
                        $('#message-text').val('');
                        $('#modal-comment').modal('hide');
                        window.setTimeout(
                            function () {
                                $('#modal-info').modal('show');
                            }, 500);
                    }
                }
            });
        });

        $('.save-folder-for-later').click(function (event) {
            event.preventDefault();

            var $language = window.location.href.split('//')[1].split('/')[1],
                $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/GetDirectoryHashUrl?hash=' + $('.save-folder-for-later').attr('data-hash');

            $.ajax({
                url: $url,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (ret) {
                    $('#modal-info .modal-title').text($(".js-text-language").attr("data-informacja"));
                    $('#modal-info .info').html($(".js-text-language").attr("data-zapisanofolder") + '<p><a href="' + ret.url + '">' + ret.url + '</a></p>');
                    window.setTimeout(
                        function () {
                            $('#modal-info').modal('show');
                        }, 500);
                }
            });
        });

        $('.save-cart-for-later').click(function (event) {
            event.preventDefault();

            var $language = window.location.href.split('//')[1].split('/')[1],
                $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/StoreContent',
                $newUrl = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/restore';

            $.ajax({
                url: $url,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (ret) {
                    if (ret.status == true) {
                        $newUrl += '?hash=' + ret.hash;
                        $('#modal-info .modal-title').text($(".js-text-language").attr("data-informacja"));
                        $('#modal-info .info').html('<strong>' + ret.info + ':</strong><br/><a href="' + $newUrl + '">' + $newUrl + '</a>');
                    } else {
                        $('#modal-info .modal-title').text($(".js-text-language").attr("data-informacja"));
                        $('#modal-info .info').text(ret.info);
                    }
                    window.setTimeout(
                        function () {
                            $('#modal-info').modal('show');
                        }, 500);
                }
            });
        });

        $('.delete-cart').click(function (event) {
            event.preventDefault();
            $('#modal-deletecart').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        });

        $('.delete-folder').click(function (event) {
            event.preventDefault();
            $('#modal-deletefolder').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        });

        function refreshCart() {
            var $language = $('html').attr('lang'),
                $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/GetBasketInfo';

            $.ajax({
                url: $url,
                success: function (ret) {
                    if (Object.keys(ret).length) {
                        $('.header-cart, .aside-cart').removeClass('hidden');
                        $('.header-cart-counter, .aside-cart-counter').text(ret.total_products_in_cart);

                    } else {
                        $('.header-cart, .aside-cart').addClass('hidden');
                    }
                }
            });
        }
    },
    counterUp: function () {
        $('.homepage-aboutus .row:last-child').one('inview', function (event, visible) {
            if (visible) {
                $('.number-count').counterUp();
            }
        });
    },
    downloadVideo: function () {
        $('.download-video').click(function (event) {
            event.preventDefault();
            var $videoNumber = $(this).attr('data-videonumber');
            getVideoDownloadLinks($videoNumber);
        });

        function getVideoDownloadLinks($videoNumber) {
            var $ajaxUrl = window.location.origin + '/ajax/getVideoDownloadUrl?number=' + $videoNumber;

            $.ajax({
                cache: false,
                url: $ajaxUrl,
                data: {'_token': $("meta[name='csrf-token']").attr('content')},
                dataType: 'json',
                type: 'post',
                success: function (ret) {
                    var videoArray = ret;
                    videoArray.sort(compareWidth);
                    videoArray.sort(compareType);
                    console.log(videoArray);

                    var $template = '\
                        <table class="resolutions">\
                            <thead>\
                                <tr>\
                                    <th>@@lang_rozdzielczosc</th>\
                                    <th>@@lang_rozmiar</th>\
                                    <th>&nbsp;</th>\
                                </tr>\
                            </thead>\
                            <tbody>\
                                @@resolutions\
                            </tbody>\
                        </table>';

                    var lang_rozdzielczosc = $('.js-text-language').attr('data-rozdzielczosc'),
                        lang_rozmiar = $('.js-text-language').attr('data-rozmiar');
                        lang_pobierz = $('.js-text-language').attr('data-pobierz');

                    var resolutions = '';

                    Object.keys(videoArray).map(function (objectKey, index) {
                        var resInfo = videoArray[objectKey].type == 'source' ? 'Original' : videoArray[objectKey].width + ' ' + videoArray[objectKey].quality.toUpperCase() + ' - ' + videoArray[objectKey].height + ' x ' + videoArray[objectKey].width;
                        resolutions += '<tr data-res="' + videoArray[objectKey].width + '">\
                                        <td data-label="' + lang_rozdzielczosc + '">' + resInfo + '</td>\
                                        <td data-label="' + lang_rozmiar + '">' + formatBytes(videoArray[objectKey].size) + '</td>\
                                        <td><a href="' + videoArray[objectKey].link + '" class="default-button default-button-fullwidth">' + lang_pobierz + '</a></td>\
                                        </tr>';
                    });

                    $template = $template.replace("@@lang_rozdzielczosc", lang_rozdzielczosc);
                    $template = $template.replace("@@lang_rozmiar", lang_rozmiar);
                    $template = $template.replace("@@resolutions", resolutions);

                    $('#modal-downloadvideo .video-frame').html($template);

                    $('#modal-downloadvideo').modal('show');
                }
            });
        }

        function compareWidth(a, b) {
            if (a.width < b.width) {
                return -1;
            }
            if (a.width > b.width) {
                return 1;
            }
            return 0;
        }

        function compareType(a, b) {
            if (a.type > b.type) {
                return -1;
            }
            if (a.type < b.type) {
                return 1;
            }
            return 0;
        }

        function formatBytes(a, b) {
            if (0 == a) return "0 Bytes";
            var c = 1024, d = b || 2, e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
                f = Math.floor(Math.log(a) / Math.log(c));
            return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f]
        }
    },
    filters: function () {
        $('.toggle-filters, .global-toggle-fixed').click(function (event) {
            event.preventDefault();
            var $this = $('.toggle-filters'),
                $t = $('.filter-options');
            if ($t.is(':visible')) {
                $t.slideUp();
                $this.children('span').text($this.attr('data-show'));
                $('.toggle-filters, .global-toggle-fixed, .homepage-stock-filters.fixed').removeClass('open');
            } else {
                $t.slideDown();
                $this.children('span').text($this.attr('data-hidden'));
                $('.toggle-filters, .global-toggle-fixed, .homepage-stock-filters.fixed').addClass('open');
            }
        });

        $('.filter-keywords').tagsinput({
            tagClass: 'label label-default'
        });

        $('.filter-keywords').on('itemAdded itemRemoved', function (event) {
            $('.bootstrap-tagsinput').popover({
                content: '',
                html: true,
                placement: 'top',
                trigger: 'manual',
                title: $('html').attr('lang') == 'pl' ? 'Szukaj słowa:' : 'Search keywords:'
            });

            var $tags = $('.bootstrap-tagsinput').clone(true, true);
            $tags.find('input').remove();
            $tags = $tags.children().length ? $tags.html() : 0;

            if ($('.bootstrap-tagsinput').data('bs.popover')) {
                $('.bootstrap-tagsinput').data('bs.popover').options.content = $tags;
            }

            if ($tags != 0) {
                $('.bootstrap-tagsinput').popover('show');
                $('.popover span[data-role="remove"]').on('click', function () {
                    var labelValue = $(this).parent('span').text();
                    $('.filter-keywords').tagsinput('remove', labelValue);
                });
            } else {
                $('.bootstrap-tagsinput').popover('hide');
            }
        });

        if ($('.bootstrap-tagsinput span').length) {
            $('.filter-keywords').trigger('itemAdded');
        }

        $('.bootstrap-tagsinput input').focus(function () {
            $('.filter-keywords').trigger('itemAdded');
        });

        $(document).mouseup(function (e) {
            var container = $(".tagscolumn");
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $('.bootstrap-tagsinput').popover('hide');
            }
        });

        $(window).on("load resize", function () {
            var winWidth = $(window).width();
            var winHeight = $(window).height();

            if (winWidth >= 992 || (winWidth >= 768 && winHeight >= 500)) {
                $(".homepage-stock-filters.fixed").mCustomScrollbar("destroy");
            } else {
                $(".homepage-stock-filters.fixed").mCustomScrollbar({
                    theme: 'dark'
                });
            }
        });

        $('.homepage-stock-filters .selectpicker').selectpicker();

        $('.selectpicker').on('rendered.bs.select', function (event, clickedIndex, newValue, oldValue) {
            var $this = $(this),
                $bootstrapSelect = $this.closest('.bootstrap-select'),
                $optGroup = $bootstrapSelect.find('.dropdown-menu .selected').attr('data-optgroup'),
                $dropdownHeader = $bootstrapSelect.find('.dropdown-menu .dropdown-header[data-optgroup="' + $optGroup + '"] .text').text();

            if ($dropdownHeader)
                $dropdownHeader = $dropdownHeader + ' ';

            if ($this.closest('.bootstrap-select').find('button').attr('title') != $this[0].title) {
                $this.closest('.bootstrap-select').find('button').attr('title', $this[0].title + ': ' + $dropdownHeader + $this.closest('.bootstrap-select').find('button').attr('title'));
            }
        });

        $('.simple-select li a:not(.unselectable)').click(function (e) {
            var $this = $(this);
            $this.closest('.dropdown-menu').find('li').removeClass('active');
            $this.closest('li').addClass('active');
            $this.closest('.dropdown').find('.dropdown-toggle').dropdown("toggle");
            $this.closest('.dropdown').find('.title').text($this.text());
        });

        $('.simple-select').on('click', 'li a:not(.unselectable)', function (e) {
            var $this = $(this);
            $this.closest('.dropdown-menu').find('li').removeClass('active');
            $this.closest('li').addClass('active');
            $this.closest('.dropdown').find('.dropdown-toggle').dropdown("toggle");
            $this.closest('.dropdown').find('.title').text($this.text());
        });

        if ($('.filter-input').length) {
            $('.filter-input').focus(function () {
                $(this).attr('placeholder', $(this).attr('data-focus'))
            }).blur(function () {
                $(this).attr('placeholder', $(this).attr('data-blur'))
            });

            var maskInputOd = vanillaTextMask.maskInput({
                inputElement: document.querySelector('.filter-input.od'),
                mask: [/\d/, /\d/, ':', /\d/, /\d/]
            });

            var maskInputDo = vanillaTextMask.maskInput({
                inputElement: document.querySelector('.filter-input.do'),
                mask: [/\d/, /\d/, ':', /\d/, /\d/]
            });
        }
    },
    flowType: function () {
        $('.homepage-aboutus-text p, .homepage-aboutus-text span').flowtype({
            minFont: 14
        });
        $('.homepage-offer-box .text h3, .homepage-offer-box .text p, .homepage-offer-box .text span').flowtype({
            minFont: 14
        });
    },
    footer: function () {
        function __bodyWindow() {
            if ($('main').height() + 120 <= $(window).height()) {
                $('footer').addClass('fixed');
            } else {
                $('footer').removeClass('fixed');
            }
        }

        __bodyWindow();

        $(window).resize(function () {
            __bodyWindow();
        });
    },
    header: function () {
        function positionFromTop() {
            if ($(window).scrollTop() > 180) {
                $('header').addClass('blackbackground');
                $('.header-blackbackgroundsubpage').addClass('smaller');
                $('.homepage-stock-filters.fixed').addClass('lowertop');
                //$('.subpage-spacer').addClass('smaller');
            } else {
                $('header').removeClass('blackbackground');
                $('.header-blackbackgroundsubpage').removeClass('smaller');
                $('.homepage-stock-filters.fixed').removeClass('lowertop');
                //$('.subpage-spacer').removeClass('smaller');
            }
        }

        $(window).scroll(function () {
            positionFromTop();
        });

        positionFromTop();

    },
    IDscroll: function () {
        $('a[href*="#"]').click(function (event) {
            var exceptions = ["hamburger", "noidscroll"];
            for (var i = 0; i < exceptions.length; i++) {
                if ($(this).hasClass(exceptions[i])) {
                    return false;
                }
            }
            var $hash = $(this)[0].hash;
            var $hash2 = $hash.replace(/\./g, '\\\\.');
            if ($($hash2).length) {
                event.preventDefault();
                var $anchor = $($hash2).offset();
                if ($hash2 == 'home') {
                    $('html, body').animate({scrollTop: $anchor.top}, 1000);
                } else {
                    $('html, body').animate({scrollTop: $anchor.top}, 1000);
                }
            } else {
                var $language = window.location.href.split('//')[1].split('/')[1];
                var $href = window.location.protocol + '//' + window.location.host + '/' + $language + '/' + $hash;
                window.location.href = $href;
            }
            return false;
        });
    },
    lazyLoad: function () {
        if ($('.homepage-stock-categories.extrapadding').length) {
            var videosID = $.parseJSON($('.data-videos').attr('data-videos')),
                hostURL = $('.data-videos').attr('data-url'),
                rozdzielczosc = $('.js-text-language').attr('data-rozdzielczosc'),
                rozmiar = $('.js-text-language').attr('data-rozmiar'),
                cena = $('.js-text-language').attr('data-cena'),
                zobacz = $('.js-text-language').attr('data-zobacz'),
                dodaj_do_koszyka = $('.js-text-language').attr('data-dodajdokoszyka'),
                filmwewszystkichfolderach = $('.js-text-language').attr('data-filmwewszystkichfolderach'),
                filmwkoszykudodajdoinnegofolderu = $('.js-text-language').attr('data-filmwkoszykudodajdoinnegofolderu'),
                filmwkoszyku = $('.js-text-language').attr('data-filmwkoszyku'),
                videoIteration = 19;
        }

        //check if user reaches bottom of page
        $(window).scroll(function () {
            if ($(window).scrollTop() + $(window).height() >= $(document).height() - 150 && $('.homepage-stock-categories.extrapadding').length != 0) {
                for (var i = 0; i < 20; i++) {
                    videoIteration++;
                    if (videoIteration < videosID.length) {
                        $('.homepage-stock-categories.extrapadding .row.global-flexcontent').append('\
                            <div class="col-ms-6 col-xs-4 col-sm-3 col-md-3 col-lg-3 col-xl-one-fifth categorycolumn" data-i="' + videoIteration + '">\
                                <div class="categorybox">\
                                    <div class="video-box">\
                                        <div class="video-image"><span class="more">' + zobacz + '</span><div class="image"></div><div class="ratio"></div></div>\
                                        <div class="video-caption"><div class="video-title" style="opacity: 0;">#</div></div>\
                                    </div>\
                                </div>\
                            </div>\
                        ');

                        $.ajax({
                            context: [videosID[videoIteration], hostURL, rozdzielczosc, rozmiar, cena, zobacz, dodaj_do_koszyka, filmwewszystkichfolderach, filmwkoszykudodajdoinnegofolderu, filmwkoszyku, videoIteration],
                            data: {'id': videosID[videoIteration]},
                            dataType: 'json',
                            type: 'post',
                            url: '/ajax/getVideoProperties',
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            },
                            success: function (ret) {
                                var $template = '\
                                    <div class="col-ms-6 col-xs-4 col-sm-3 col-md-3 col-lg-3 col-xl-one-fifth categorycolumn">\
                                        <div class="categorybox">\
                                            <div class="video-box loaded" data-id="@@videoID">\
                                                <a href="@@hostURL?numer=@@videoNumber" class="video-image">\
                                                    <span class="more">@@lang_zobacz</span>\
                                                    <div class="image loaded" style="background-image: url(/img/500-resize/@@videoThumbnail);">\
                                                    </div>\
                                                    <div class="ratio"></div>\
                                                </a>\
                                                <div class="video-caption">\
                                                    <div class="video-title">#@@videoNumber</div>\
                                                    <div class="video-button text-center">@@buttonContent</div>\
                                                    <table class="resolutions resolutions-stock hidden" data-id="@@videoID">\
                                                        <thead>\
                                                            <tr>\
                                                                <th>@@lang_rozdzielczosc</th>\
                                                                <th>@@lang_rozmiar</th>\
                                                                <th>@@lang_cena</th>\
                                                                <th>&nbsp;</th>\
                                                            </tr>\
                                                        </thead>\
                                                        <tbody>\
                                                            @@resolutions\
                                                        </tbody>\
                                                    </table>\
                                                    <div class="video-details">\
                                                        <div class="video-time">\
                                                            <i class="icon-czas"></i>\
                                                            <span class="video-time-value">@@videoDuration</span>\
                                                        </div>\
                                                        <div class="video-resolution">\
                                                            <i class="icon-rozdzielczosc"></i>\
                                                            <span class="video-resolution-value">@@videoResolution</span>\
                                                        </div>\
                                                    </div>\
                                                </div>\
                                            </div>\
                                        </div>\
                                    </div>';

                                var videoID = this[0],
                                    videoNumber = ret.number,
                                    hostURL = this[1],
                                    videoThumbnail = ret.thumb,
                                    lang_rozdzielczosc = this[2],
                                    lang_rozmiar = this[3],
                                    lang_cena = this[4],
                                    lang_zobacz = this[5],
                                    lang_dodaj_do_koszyka = this[6],
                                    lang_filmwewszystkichfolderach = this[7],
                                    lang_filmwkoszykudodajdoinnegofolderu = this[8],
                                    lang_filmwkoszyku = this[9],
                                    videoDuration = ret.videoproperty.dlugosc,
                                    videoResolution = Object.keys(ret.sorted_prop)[0],
                                    currentIteration = this[10];


                                $template = $template.replace(/@@videoID/g, videoID);
                                $template = $template.replace(/@@videoNumber/g, videoNumber);
                                $template = $template.replace("@@hostURL", hostURL);
                                $template = $template.replace("@@videoThumbnail", videoThumbnail);
                                $template = $template.replace("@@lang_rozdzielczosc", lang_rozdzielczosc);
                                $template = $template.replace("@@lang_rozmiar", lang_rozmiar);
                                $template = $template.replace("@@lang_cena", lang_cena);
                                $template = $template.replace("@@lang_zobacz", lang_zobacz);
                                $template = $template.replace("@@videoDuration", videoDuration);
                                $template = $template.replace("@@videoResolution", videoResolution);

                                if (ret.basket_info_c == 'dodaj_do_koszyka') {
                                    var buttonContent = '\
                                        <a href="#" class="add-to-cart noidscroll default-circlebutton pull-right"\
                                            data-id="' + videoID + '" data-toggle="tooltip" data-placement="bottom" title="' + lang_dodaj_do_koszyka + '">\
                                                <i class="icon-koszyk_2"></i>\
                                        </a>';
                                    $template = $template.replace("@@buttonContent", buttonContent);
                                } else if (ret.basket_info_c == 'w_koszyku') {
                                    var buttonContent = '\
                                        <a href="#" class="default-button-nopointer default-circlebutton noidscroll pull-right"\
                                            data-id="' + videoID + '" data-toggle="tooltip" data-placement="bottom" title="' + lang_filmwkoszyku + '">\
                                        <i class="icon-koszyk_2 color-orange"></i>\
                                    </a>';
                                    $template = $template.replace("@@buttonContent", buttonContent);
                                } else if (ret.basket_info_c == 'w_koszyku_dodaj_do_innego_folderu') {
                                    var buttonContent = '\
                                        <a href="#" class="add-to-cart noidscroll default-circlebutton pull-right"\
                                            data-id="' + videoID + '" data-toggle="tooltip" data-placement="bottom" title="' + lang_filmwkoszykudodajdoinnegofolderu + '">\
                                        <i class="icon-koszyk_2 color-orange"></i>\
                                    </a>';
                                    $template = $template.replace("@@buttonContent", buttonContent);
                                } else {
                                    var buttonContent = '\
                                        <a href="#" class="default-button-nopointer noidscroll default-circlebutton pull-right"\
                                            data-id="' + videoID + '" data-toggle="tooltip" data-placement="bottom" title="' + lang_filmwewszystkichfolderach + '">\
                                        <i class="icon-koszyk_2 color-orange"></i>\
                                    </a>';
                                    $template = $template.replace("@@buttonContent", buttonContent);
                                }

                                var resolutions = '';

                                Object.keys(ret.prop).map(function (objectKey, index) {
                                    var specificResolution = ret.prop[objectKey].rozdzielczosc != '' ? ' - ' + ret.prop[objectKey].rozdzielczosc : '';
                                    resolutions += '<tr data-res="' + ret.prop[objectKey].res + '">\
                                        <td data-label="' + rozdzielczosc + '">' + ret.prop[objectKey].res + specificResolution + '</td>\
                                        <td data-label="' + rozmiar + '">' + ret.prop[objectKey].size + ' MB</td>\
                                        <td data-label="' + cena + '">' + ret.prop[objectKey].price + ' PLN</td>\
                                        <td></td>\
                                        </tr>';
                                });

                                $template = $template.replace("@@resolutions", resolutions);

                                $('.homepage-stock-categories.extrapadding .row.global-flexcontent .categorycolumn[data-i="' + currentIteration + '"]').replaceWith($template);

                                LEMON.cartFunctions(false);
                                LEMON.IDscroll();
                            }
                        });
                    }
                }
            }
        });

        var myLazyLoad = new LazyLoad({
            elements_selector: ".video-image .lazyload-trigger",
            threshold: 0,
            class_loaded: 'loaded',
            callback_error: function (el) {
                callback(el);
            },
            callback_load: function (el) {
                callback(el);
            }
        });

        function callback(el) {
            var imgArea = el.parentNode;
            var imgSrc = el.getAttribute('data-src');
            $.ajax({
                data: {'id': imgArea.dataset.id},
                dataType: 'json',
                type: 'post',
                url: '/ajax/getVideoProperties',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (ret) {
                    $('.video-box[data-id="' + imgArea.dataset.id + '"] .video-time-value').text(ret.videoproperty.dlugosc);
                    $('.video-box[data-id="' + imgArea.dataset.id + '"] .video-resolution-value').text(Object.keys(ret.sorted_prop)[0]);
                    var rozdzielczosc = $('.video-box[data-id="' + imgArea.dataset.id + '"] .resolutions thead th:nth-child(1)').text(),
                        rozmiar = $('.video-box[data-id="' + imgArea.dataset.id + '"] .resolutions thead th:nth-child(2)').text(),
                        cena = $('.video-box[data-id="' + imgArea.dataset.id + '"] .resolutions thead th:nth-child(3)').text(),
                        resolutions;
                    Object.keys(ret.prop).map(function (objectKey, index) {
                        var specificResolution = ret.prop[objectKey].rozdzielczosc != '' ? ' - ' + ret.prop[objectKey].rozdzielczosc : '';
                        resolutions += '<tr data-res="' + ret.prop[objectKey].res + '">\
                            <td data-label="' + rozdzielczosc + '">' + ret.prop[objectKey].res + specificResolution + '</td>\
                            <td data-label="' + rozmiar + '">' + ret.prop[objectKey].size + ' MB</td>\
                            <td data-label="' + cena + '">' + ret.prop[objectKey].price + ' PLN</td>\
                            <td></td>\
                            </tr>';
                    });
                    $('.video-box[data-id="' + imgArea.dataset.id + '"] .resolutions tbody').append(resolutions);
                    imgArea.style.backgroundImage = `url('${imgSrc}')`;
                    $('.video-box[data-id="' + imgArea.dataset.id + '"]').addClass('loaded');
                    imgArea.classList.add('loaded');
                    el.parentNode.removeChild(el);
                }
            });
        }
    },
    menu: function () {
        var $toggle = $('.hamburger'),
            $aside = $('aside');

        $toggle.click(function (e) {
            $aside.toggleClass('active');
            $(this).toggleClass('is-active');
            return false;
        });

        $('.aside-menu li a').click(function () {
            $('.hamburger').removeClass('is-active');
            $('aside').removeClass('active');
        });

        $(".aside-container").mCustomScrollbar();
    },
    order: function () {
        function sticky() {
            $(document.body).trigger("sticky_kit:recalc");
            if ($(window).width() < 768) {
                $(".order-main-sticky").trigger("sticky_kit:detach");
            } else {
                $(".order-main-sticky").stick_in_parent({
                    parent: '.row',
                    offset_top: 140
                });
            }
        }

        $(window).resize(function () {
            var w = $(window).width();
            if (typeof checkw == 'undefined') checkw = w;
            if (w != checkw) {
                sticky();
                checkw = w;
            }
        });

        sticky();

        if ($('.order-main-form').hasClass('show-info-modal')) {
            setTimeout(function () {
                if (Cookies.get('info_order') != 1) {
                    $('#modal-infoorder').modal({
                        backdrop: 'static',
                        keyboard: false,
                        show: true
                    });
                }
            }, 1000);
        }

        $('.show-infoorder').click(function () {
            $('#modal-infoorder').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        });

        $('#modal-infoorder button').click(function () {
            Cookies.set('info_order', 1, {expires: 31});
        });

        $('form.order-main-form').submit(function (e) {
            var $allRequiredFill = true;
            $('.required').removeClass('border-orange');
            $('.checkbox-text').removeClass('text-orange');
            $('.required-inputs .required').each(function () {
                if ($(this).val() == '') {
                    if ($(this).hasClass('extra-required')) {
                        if ($('input[name="fv_dane_radio"]:checked').val() == 'other') {
                            $(this).addClass('border-orange');
                            $allRequiredFill = false;
                        }
                    } else {
                        $(this).addClass('border-orange');
                        $allRequiredFill = false;
                    }
                }
            });
            $(".order-main-form input[type='checkbox']").each(function () {
                if (!$(this).is(':checked')) {
                    $(this).next('.checkbox-text').addClass('text-orange');
                    $allRequiredFill = false;
                }
            });
            if ($(this).data('ajax') != undefined && $(this).data('ajax') && $allRequiredFill) {
                $('.alert-form-js').remove();
                $('.hide-on-success').addClass('is-sending');
                if ($('html').attr('lang') == 'en') {
                    $('.hide-on-success').addClass('is-sending-en');
                }
                var form = $(this);
                e.preventDefault();
                var url = form.attr('action');

                //var form_data = JSON.stringify(form.serializeArray());

                var form_data = {};
                form.find('*[name]').each(function () {
                    form_data[$(this).attr('name')] = $(this).val();
                });

                form.find('input[type="submit"]').attr('disabled', true);
                form.find('button[type="submit"]').attr('disabled', true);

                $.ajax({
                    url: url,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    data: form_data,
                    dataType: 'json',
                    type: 'post',
                    success: function (ret) {
                        form.find('input[type="submit"]').attr('disabled', false);
                        form.find('button[type="submit"]').attr('disabled', false);
                        $('.hide-on-success').removeClass('is-sending');
                        $('.hide-on-success').removeClass('is-sending-en');

                        var alert_class = 'alert alert-success alert-form-js';
                        if (!ret.success)
                            alert_class = 'alert alert-danger alert-form-js';

                        var error_container = $('<div>').addClass(alert_class);
                        var list = $('<ul>');

                        if (ret.success) {
                            $('.hide-on-success').hide();
                            list.append('<li>' + ret.info + '</li>');

                            if (ret.payment_redirect != undefined)
                                window.location.href = ret.payment_redirect;

                        } else {
                            for (i in ret.info) {
                                list.append('<li>' + ret.info[i] + '</li>');
                            }
                        }
                        error_container.append(list);
                        if (form.find('.alert-box').length) {
                            if (!ret.success) {
                                $('.alert-box').prepend(error_container);
                            } else {
                                form.prepend(error_container);
                            }
                        } else {
                            form.prepend(error_container);
                        }
                        $('html, body').animate({scrollTop: $('.alert').offset().top - 100}, 500);
                    },
                    error: function (xhr, textStatus, errorThrown) {
                        $('.alert-form-js').remove();
                        form.find('input[type="submit"]').attr('disabled', false);
                        form.find('button[type="submit"]').attr('disabled', false);
                        $('.hide-on-success').removeClass('is-sending');
                        $('.hide-on-success').removeClass('is-sending-en');
                        var error_container = $('<div>').addClass('alert alert-danger alert-form-js');
                        if ($('html').attr('lang') == 'en') {
                            var list = $('<ul><li>An error occurred during the sending form.</li><li>Please try again.</li></ul>');
                        } else {
                            var list = $('<ul><li>Wystąpił błąd w czasie wysyłania formularza.</li><li>Proszę spróbować ponownie.</li></ul>');
                        }
                        error_container.append(list);
                        if (form.find('.alert-box').length) {
                            if (!ret.success) {
                                $('.alert-box').prepend(error_container);
                            } else {
                                form.prepend(error_container);
                            }
                        } else {
                            form.prepend(error_container);
                        }
                        $('html, body').animate({scrollTop: $('.alert').offset().top - 100}, 500);
                        e.preventDefault();
                    }
                })
            } else {
                $('.alert-form-js').remove();
                var error_container = $('<div>').addClass('alert alert-danger alert-form-js');
                if ($('html').attr('lang') == 'en') {
                    var list = $('<ul><li>Fill in all required fields</li></ul>');
                } else {
                    var list = $('<ul><li>Wypełnij wszystkie pola z gwiazdkami</li></ul>');
                }
                error_container.append(list);
                var form = $(this);
                if (form.find('.alert-box').length) {
                    if (!ret.success) {
                        $('.alert-box').prepend(error_container);
                    } else {
                        form.prepend(error_container);
                    }
                } else {
                    form.prepend(error_container);
                }
                $('html, body').animate({scrollTop: $('.alert').offset().top - 100}, 500);
                e.preventDefault();
            }
        });
    },
    parallax: function () {
        function parallax() {
            var images;

            function init() {
                images = [].slice.call(document.querySelectorAll('.parallax'));
                if (!images.length) {
                    return
                }
                if (window.mobileAndTabletcheck()) {
                    $('.parallax').css("background-attachment", "scroll");
                    return;
                }
                $(window).on('scroll', doParallax);
                $(window).on('resize', doParallax);
                doParallax();
            }

            function getViewportHeight() {
                var a = document.documentElement.clientHeight, b = window.innerHeight;
                return a < b ? b : a;
            }

            function getViewportScroll() {
                if (typeof window.scrollY != 'undefined') {
                    return window.scrollY;
                }
                if (typeof pageYOffset != 'undefined') {
                    return pageYOffset;
                }
                var doc = document.documentElement;
                doc = doc.clientHeight ? doc : document.body;
                return doc.scrollTop;
            }

            function doParallax() {
                var el, elOffset, elHeight,
                    offset = getViewportScroll(),
                    vHeight = getViewportHeight();

                for (var i in images) {
                    el = images[i];
                    //elOffset = el.offsetTop;
                    elOffset = $('.' + el.classList[0]).offset().top;
                    elHeight = el.offsetHeight;

                    if ((elOffset > offset + vHeight) || (elOffset + elHeight < offset)) {
                        continue;
                    }

                    el.style.backgroundPosition = '50% ' + Math.round((elOffset - offset) * 3 / 8) + 'px';
                }
            }

            return {
                init: init
            }
        }

        parallax().init();
    },
    realizations: function () {
        $('.homepage-realizations-carousel').owlCarousel({
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 7000,
            center: true,
            dots: true,
            dotsEach: true,
            dotsContainer: '.homepage-realizations-dots',
            items: 3,
            loop: true,
            nav: true,
            navContainer: '.homepage-realizations-controls',
            navText: ['<i class="icon-strzalka_lewo"></i>', '<i class="icon-strzalka_prawo"></i>'],
            smartSpeed: 500,
            responsive: {
                0: {
                    items: 1
                },
                481: {
                    items: 3
                }
            }
        });

        $('.magnific-iframe').magnificPopup({
            type: 'iframe',
            tClose: 'Zamknij (Esc)',
            tLoading: 'Wczytywanie...',
            mainClass: 'mfp-fade',
            callbacks: {
                open: function () {
                    $('.homepage-realizations-carousel').trigger('stop.owl.autoplay');
                },
                close: function () {
                    $('.homepage-realizations-carousel').trigger('play.owl.autoplay');
                }
            }
        });

        $('.homepage-realizations-logos-carousel').owlCarousel({
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 0,
            dots: false,
            items: 6,
            loop: true,
            nav: false,
            navContainer: '.homepage-realizations-logos-controls',
            navText: ['<i class="icon-chevron_lewo"></i>', '<i class="icon-chevron_prawo"></i>'],
            smartSpeed: 3000,
            responsive: {
                0: {
                    items: 1
                },
                361: {
                    items: 2
                },
                480: {
                    items: 3
                },
                768: {
                    items: 4
                },
                992: {
                    items: 5
                },
                1200: {
                    items: 6
                }
            }
        });
    },
    scrollSpy: function () {
        function __handleScroll() {
            var akt = '';

            $('section[data-adres]').each(function () {
                var o = $(this).offset().top;
                var t = $(window).scrollTop() + $(window).height() / 2;
                var b = $(window).scrollTop();

                function isElementInViewport(el) {
                    if (typeof jQuery === "function" && el instanceof jQuery) {
                        el = el[0];
                    }
                    var rect = el.getBoundingClientRect();
                    if ((el.getAttribute('id') == 'kontakt') || (el.getAttribute('id') == 'contact')) {
                        return rect.bottom <= $(window).height();
                    } else {
                        return rect.top >= 0 && rect.top <= $(window).height() / 2
                    }
                }

                if (isElementInViewport($(this))) {
                    var adr = $(this).attr('data-adres'), id = $(this).attr('id');
                    if (typeof id == 'undefined') {
                        id = $(this).find('.global-idscroll').attr('id');
                    }
                    if (akt !== adr) {
                        akt = adr;
                        //$.address.value(id);
                        //var subtitle = $('.header-menu-desktop').find('li a[href*="#'+id+'"]').text();
                        /*
                        if(subtitle == ''){
                            subtitle = $(this).attr('data-title');
                        }
                        */
                        //$.address.title(subtitle + ' | Unit 80');
                        $('.header-menu-desktop, .aside-menu').find('li.active').removeClass('active');
                        $('.header-menu-desktop, .aside-menu').find('li a[href*="#' + id + '"]').parent('li').addClass('active');
                    }
                }
            });
        }

        if ($.address.value() !== '' && $.address.value() !== '/') {
            var a = $.address.value();
            a = a.substr(1);
            if (a != '' && $('#' + a).length != 0 && window.location.href.split('//')[1].split('/')[1].indexOf('#') == -1) {
                $('html, body').stop().animate({scrollTop: $('#' + a).offset().top - 100}, 500, function () {
                });
            }
        }

        if ($(window).scrollTop() < 90) {
            if ($('section[data-adres]').length != 0) {
                //$.address.title('Home | Unit 80');
                $('.header-menu-desktop, .aside-menu').find('li.active').removeClass('active');
                $('.header-menu-desktop, .aside-menu').find('li:first-child:not(.dropdown)').addClass('active');
            }
        }

        var scroll = 0;

        $(window).scroll(function () {
            if (scroll > 0) {
                __handleScroll();
            }
            scroll++;
        });
    },
    video: function () {
        var $sectionVideos = [$('main').find('.video-selfhosted')];
        $sectionVideos.forEach(function (event) {
            var $this = event,
                mp4 = typeof $this.attr('data-mp4') == 'undefined' ? '' : '<source type="video/mp4"  src="' + $this.attr('data-mp4') + '">',
                webm = typeof $this.attr('data-mp4') == 'undefined' ? '' : '<source type="video/webm"  src="' + $this.attr('data-webm') + '">',
                speed = typeof $this.attr('data-speed') == 'undefined' ? '' : $this.attr('data-speed'),
                loop = typeof $this.attr('data-loop') == 'undefined' ? '' : 'loop',
                $video = '<video playsinline="" autoplay="" {{loop_boolean}}> \
														{{webm_source}}\
														{{mp4_source}}\
													</video>';

            var initVideo = function () {
                if ($this.find('video').length) {
                    $this.find('video')[0].playbackRate = parseFloat(speed);
                    $this.find('video')[0].play();
                } else {
                    if (mp4 != '' && webm != '') {
                        var _video = $video.replace('{{mp4_source}}', mp4);
                        _video = _video.replace('{{webm_source}}', webm);
                        _video = _video.replace('{{loop_boolean}}', loop);
                        $this.append($(_video));
                        $this.find('video')[0].load();
                        $this.find('video')[0].playbackRate = parseFloat(speed);
                    }
                }
            };
            if (!window.mobileAndTabletcheck() || $(window).width() >= 992) {
                initVideo();
            }
        });
    },
    discountCode: function () {
        $("#apply-discount-code").click(function (e) {
            $language = window.location.href.split('//')[1].split('/')[1].replace('#', ''),
                $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/checkDiscountCode',

                e.preventDefault();

            $("#code_invalid_info").hide();

            $("#code_invalid").hide();
            $("#code_invalid_info").hide();
            var code = $("input[name='discount-code']").val();
            $.ajax({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                url: $url,
                data: {code: code},
                dataType: 'json',
                type: 'post',
                success: function (ret) {
                    if (ret != undefined && ret) {
                        if (ret.status == false) {
                            $("#code_invalid_info").text(ret.info);
                            $("#code_invalid_info").show();
                        } else {
                            $("#discount-valid").show();
                            $("#priceAfterDiscount").show();
                            $("#discount-form").hide();

                            $("#discount-valid span#discount-valid-code").text(ret.code);
                            $("#priceAfterDiscount span").text(ret.after_discount);
                        }
                    }
                }
            })
        });

        $("#cancel-discount-code").click(function (e) {
            $language = window.location.href.split('//')[1].split('/')[1].replace('#', ''),
                $url = window.location.protocol + '//' + window.location.host + '/' + $language + '/stock/basket/ajax/clearDiscountCode',

                e.preventDefault();

            $.ajax({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                url: $url,
                data: {},
                dataType: 'json',
                type: 'post',
                success: function (ret) {
                    if (ret != undefined && ret.status) {
                        $("#discount-valid").hide();
                        $("#priceAfterDiscount").hide();
                        $("#discount-form").show();
                    }
                }
            });
        });
    }
};


for (var funkcja in LEMON) {
    LEMON[funkcja]();
}